// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1KMX3","content":"styles_content__2v-5E","selectAll":"styles_selectAll__1DCV_"};